import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { PreguntaService } from 'src/app/services/pregunta.service';

@Component({
  selector: 'app-relacionados',
  templateUrl: './relacionados.component.html',
  styleUrls: ['./relacionados.component.css']
})
export class RelacionadosComponent implements OnInit {


  preguntasRelacionadas:any
  ruta:string;
  hayRelacionados:boolean;
  loading:boolean;
  @Input() id: number;

  constructor(private actRouter:ActivatedRoute, private router:Router, private preguntaService:PreguntaService) {}

  ngOnInit(): void {
    this.loading = true;
    this.actRouter.params.subscribe(params=>{
      this.id = params['id'];
     })
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation="reload"
    this.preguntaService.getRelacionadasPublic(this.id)
     .subscribe(
        resp => {
          this.preguntasRelacionadas = resp;

            if (this.preguntasRelacionadas === null || this.preguntasRelacionadas === undefined || this.preguntasRelacionadas.length ==0 )
          {
              this.hayRelacionados = false;
          }
          else{
            this.hayRelacionados = true;
          }
          this.loading = false;
        },
        error => {
          console.error(error);
          this.hayRelacionados = false;
          this.loading = false;
        }
       )
  }

  responderPregunta(id:number)
  {
    this.ruta = 'help/respuesta/'+id;
    this.router.navigateByUrl(this.ruta);

  }


}
